import { Box, Button, useTheme } from '@mui/material';
import { Typography } from '../../../../components/Typography/Typography';
import { ReactComponent as ChevronDownIcon } from '../../../../assets/icons/chevron-down.svg';

type Props = {
  selectedCount: number;
  onClearSelection: () => void;
  onOpenCopyMenu: (anchor: HTMLElement) => void;
};

export function MonthViewSelectionToolbar({
  selectedCount,
  onClearSelection,
  onOpenCopyMenu,
}: Props) {
  const { colors } = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 1.5,
        px: 2,
        py: 1.25,
        bgcolor: colors.surfaceAccent.default,
        borderBottom: `1px solid ${colors.border.default}`,
      }}
    >
      <Typography variant='body' color={colors.text.main} style={{ fontWeight: 600 }}>
        {selectedCount} {selectedCount === 1 ? 'deal' : 'deals'} selected
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Button
          variant='contained'
          disableElevation
          size='small'
          endIcon={
            <ChevronDownIcon
              style={{ width: 18, height: 18 }}
              aria-hidden
            />
          }
          sx={{
            bgcolor: '#1B2240',
            color: colors.icon.inverse,
            textTransform: 'none',
            fontWeight: 600,
            fontSize: 14,
            letterSpacing: '0.02em',
            borderRadius: '8px',
            px: 1.75,
            py: 0.75,
            boxShadow: 'none',
            '& .MuiButton-endIcon': { ml: 0.5, '& svg path': { fill: 'currentColor' } },
            '&:hover': { bgcolor: '#232a4d', boxShadow: 'none' },
          }}
          onClick={(e) => onOpenCopyMenu(e.currentTarget)}
        >
          Copy to
        </Button>
        <Button
          variant='text'
          size='small'
          sx={{ color: colors.text.main, textTransform: 'none', minWidth: 0, px: 0.5 }}
          onClick={onClearSelection}
        >
          <Typography variant='subtitle1' color={colors.text.main} style={{ fontWeight: 500 }}>
            Clear Selection
          </Typography>
        </Button>
      </Box>
    </Box>
  );
}
